import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import Radio, { RadioProps } from '@mui/material/Radio';
import React from 'react'
import { RhfStyleProps } from '../types/RhfStyleProps';
import Label from './Label';

// & Omit<FormControlLabelProps, "control">
type Props = RhfStyleProps & {
  value: unknown;
  label: React.ReactNode;
  formControlLabelProps?: FormControlLabelProps
  markProps?: RadioProps;
}

/**
 * 無受控的 Radio
 */
const RadioButton = ({
  sx, className, style,// RhfStyleProps
  value, label,

  markProps,
  formControlLabelProps,
  ...restProps
}: Props) => {
  if (sx == null) {
    sx = { marginRight: 3 } // 右側稍微留白
  }

  return (
    <FormControlLabel {...formControlLabelProps}
      value={value}
      label={(typeof (label) === "string" ? <Label text={label} /> : label)}
      control={<Radio {...markProps}
      />}
    />
  )
}

export default RadioButton